export default "__VITE_ASSET__Bqxb7C2x__"